import { render, staticRenderFns } from "./VirtualReview.vue?vue&type=template&id=78428ee6&scoped=true"
import script from "./VirtualReview.vue?vue&type=script&lang=js"
export * from "./VirtualReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78428ee6",
  null
  
)

export default component.exports